// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__Xvx3f","imgQr":"styles_imgQr__S_VGE","contentImg":"styles_contentImg__3nj6s","text":"styles_text__48mbN"};